import React from 'react'

import { Button } from '@interco/inter-ui/components/Button'
import { Text } from '@interco/inter-ui/components/Text'
import { Spacing } from '@interco/inter-ui/components/Spacing'
import { interWbNavigate } from '@interco/inter-webview-bridge'
import { requestAnalytics } from '@/services/bridge'

import * as S from './styles'
import { IconList } from '../icon-list'

export const LimitTotalUsed = ({
  icon,
  title,
  description,
  actionOptions,
}: OverdraftDetailsComponent) => {
  const handleAction = ({
    actionUrl,
  }: Pick<OverdraftDetailsComponentActionOption, 'actionUrl'>) => {
    requestAnalytics('CHEQUEESPECIAL_FLUXO', {
      screen: 'Home do contrato',
      ref_type: 'botão',
      content_action: 'toque',
      content_id: '',
      product: 'ChequeEspecial',
    })

    if (actionUrl) {
      interWbNavigate.openDeepLink(actionUrl)
    }
  }

  return (
    <S.Container>
      {icon && (
        <>
          <IconList name={icon} iconSize={24} color="var(--error500)" />
          <Spacing mb="xs" />
        </>
      )}
      {title && (
        <>
          <Text variant="headline-h3" semiBold>
            {title}
          </Text>
          <Spacing mb="xxs" />
        </>
      )}
      {description && (
        <>
          <Text variant="body-3">{description}</Text>
          <Spacing mb="sm" />
        </>
      )}

      {actionOptions && actionOptions.length > 0 && (
        <S.ContentActions>
          {actionOptions.map((item, idx) => (
            <>
              <Button
                variant={item.actionVariant ?? 'primary'}
                onClick={() =>
                  handleAction({
                    // type: item.type,
                    actionUrl: item.actionUrl,
                  })
                }
              >
                {item.title}
              </Button>
              {idx + 1 < actionOptions.length && <Spacing mb="xxxs" />}
            </>
          ))}
        </S.ContentActions>
      )}
    </S.Container>
  )
}
